import { getInitialState } from './state';

const mutations = {
  SET_CLEAR_CPFSEARCHED(state) {
    Object.assign(state, getInitialState());
  },

  SET_CPF_SEARCHED(state, cpf) {
    state.data.cpf = cpf;
  }
};

export default mutations;
